// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__X7GKb","row":"styles_row__3sB4Q"};